// extracted by mini-css-extract-plugin
export default {"permission_wrapper":"NoPermission_permission_wrapper__nWyHp","permission_tip":"NoPermission_permission_tip__yT3uW"};